export default "__VITE_ASSET__CjyKJD$P__";